import { graphql } from "@/lib/gql/__generated__/gql";

export const RE_ONBOARDING_REQUEST_MUTATION = graphql(/* GraphQL */ `
	mutation ReOnboardingRequestMutation($input: ReOnboardingRequestInput!) {
		reOnboardingRequest(input: $input) {
			message
			userErrors
		}
	}
`);
